var exports = {
  "Qs": "x61f99309--f45c25--content",
  "Qq": "x61f99309--f45c25--text",
  "VA": "x61f99309--f45c25--subtitle",
  "_8": "x61f99309--f45c25--img",
};

module.exports = exports;
